export const selectWorkspaces = (state) => {
    return state.stylovyzeWorkspaces.workspaces;
};
